<script>
/**
 * Widget Component
 */
export default {
  data() {
    return {
      statData: [
        {
          title: 'تعداد اپلیکیشن ها',
          icon: 'ri-apps-line',
          value: this.$store.state.dashboard.dashboardData.total
            .total_applications,
        },
        {
          title: 'تعداد کمپین ها',
          icon: 'ri-advertisement-line',
          value: this.$helper.formatPrice(
            this.$store.state.dashboard.dashboardData.total.total_campaigns
          ),
        },
        {
          title: 'تعداد لیگ ها',
          icon: 'ri-gamepad-line',
          value: this.$helper.formatPrice(
            this.$store.state.dashboard.dashboardData.total.total_leagues
          ),
        },
        {
          title: 'درآمد امروز',
          icon: 'ri-money-dollar-circle-line',
          value: this.$helper.formatPrice(
            this.$store.state.dashboard.dashboardData.total.today_income
          ),
        },
        {
          title: 'کاربران جدید',
          icon: 'ri-user-line',
          value: this.$helper.formatPrice(
            this.$store.state.dashboard.dashboardData.total.new_players
          ),
        },
      ],
    }
  },
}
</script>

<template>
  <div class="row">
    <div class="col-md-4" v-for="(data, index) in statData" :key="index">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">{{ data.title }}</p>
              <h4 class="mb-0">{{ data.value }}</h4>
            </div>
            <div class="text-primary">
              <i :class="`${data.icon} font-size-24`"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->
</template>
